import * as Highcharts from 'highcharts';
import { ReusableFunctions } from '../classes/reusable-functions';
import { Router } from '@angular/router';

export class HistoricalTrendsChartOptions {
    constructor(private reusableFunctions: ReusableFunctions, private router: Router) {}

    public createNewHistoricalChartOptions(
        title: string,
        xAxisText: string,
        yAxisText: string,
        seriesData: any[],
        urlSegment: string,
        drillDownBaseUrl: string,
        milestoneKey: number,
        hasDrilldownAccsess: boolean,
        yMax?: number,
        hideTitle?: boolean
    ): Highcharts.Options {
        if (yAxisText.toLowerCase() === 'volume') {
            yAxisText = yAxisText + ' ($)';
        }

        const _this = this;

        var chartOptions: Highcharts.Options = {
            chart: {
                spacingBottom: 8,
                spacingLeft: 0,
                marginRight: 0,
                spacingRight: 0,
                reflow: true,
                spacingTop: hideTitle ? 5 : 0,
            },
            title: {
                text: hideTitle ? '' : title,
                style: {
                    color: '#333333',
                    fontSize: '27px',
                },
                align: 'left',
                x: 22,
            },
            credits: {
                enabled: false,
            },
            series: seriesData,
            exporting: {
                enabled: false,
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: false,
                            },
                        },
                    },
                },
            },
            xAxis: [
                {
                    type: 'category',
                    startOnTick: true,
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    title: {
                        text: xAxisText,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                } as Highcharts.XAxisOptions,
            ],
            yAxis: [
                {
                    title: {
                        text: yAxisText,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    max: yMax,
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    lineWidth: 1,
                } as Highcharts.YAxisOptions,
            ],
            legend: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    maxPointWidth: 52,
                    groupPadding: 0,
                    lineWidth: 3,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    pointStart: 0,
                    dataGrouping: {
                        enabled: false,
                    },
                    cursor: hasDrilldownAccsess ? 'pointer' : 'default',
                    point: {
                        events: {
                            click: function (point) {
                                if (hasDrilldownAccsess) {
                                    _this.router.navigate([drillDownBaseUrl, urlSegment], {
                                        queryParams: {
                                            year: this.properties.year,
                                            milestonekey: milestoneKey,
                                            selectedPeriod: this.properties.datePeriod,
                                        },
                                    });
                                }
                            },
                        },
                    },
                } as Highcharts.PlotSeriesOptions,
            },
            tooltip: {
                shared: true,
                useHTML: true,
                borderColor: '#223540',
                fontFamily: 'Roboto',
                formatter: function () {
                    return (
                        '<table>' +
                        this.points.reduce(function (s, point) {
                            const isWeekly = point.point.properties.amountPercentChange === null;
                            let amountPercentChange = '';
                            if (!isWeekly) {
                                const percent = point.point.properties.amountPercentChange;
                                if (percent < 0) {
                                    amountPercentChange = `(${Math.abs(
                                        percent
                                    ).toLocaleString()}%)`;
                                } else if (percent === 0) {
                                    amountPercentChange = '--';
                                } else {
                                    amountPercentChange = percent.toLocaleString() + '%';
                                }
                            }
                            s += `<tr>
                                    <td style="color: ${
                                        point.point.color
                                    }; padding-right: 10px;"><b>${point.point.properties.datePeriodDescription.toUpperCase()}</b></td>
                                    <td style="text-align: right">${_this.reusableFunctions.formatMoney(
                                        point.point.properties.volume
                                    )}</td>
                                    <td style="padding: 0 5px 0 5px">/</td>
                                    <td style="text-align: right">${point.point.properties.units.toLocaleString()}</td>
                                    ${
                                        isWeekly
                                            ? ''
                                            : `<td style="padding: 0 5px 0 5px">/</td><td style="text-align: right">${amountPercentChange}</td>`
                                    }
                                    
                                </tr>
                                `;
                            return s;
                        }, '<tr style="line-height: 18px; font-size: 16px"><td colSpan="4"><b>' +
                            title +
                            '<b></td></tr>') +
                        '</table>'
                    );
                },
            } as Highcharts.TooltipOptions,
        };
        return chartOptions;
    }
}
